import { useTranslation } from 'react-i18next';

import { Typography } from '@speeki/global-ui-components';

import SpeekiLogo from '@assets/images/speeki_logo.svg';

import {
    ContainerInner,
    ContainerSection,
} from '@components/_global/GlobalStyle/Global.styled';
import { Container } from '@components/ions/layouts';
import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout';

import { useUserCompany } from '@utils/hooks/useUserCompany';

import { HeaderSkeleton } from '@domains/settings/molecules/HeaderSkeleton/HeaderSkeleton';
import { OptionsSkeleton } from '@domains/settings/molecules/OptionsSkeleton/OptionsSkeleton';
import { UserOptions } from '@domains/settings/organisms/UserOptions/UserOptions';

import { CompanyLogo, SettingsHeader } from './SettingsPage.styled';

export const SettingsPage = () => {
    const { t } = useTranslation();
    const { called, data, loading: userInfoLoading } = useUserCompany();

    return (
        <DefaultLayout>
            <Container>
                <ContainerInner>
                    <ContainerSection>
                        {!called && userInfoLoading ? (
                            <HeaderSkeleton />
                        ) : (
                            <SettingsHeader>
                                <Typography.TextH2_28_44>
                                    {t('SETTINGS')}
                                </Typography.TextH2_28_44>
                                <CompanyLogo
                                    src={
                                        data?.user?.tenant?.logo ||
                                        (SpeekiLogo as string)
                                    }
                                />
                            </SettingsHeader>
                        )}
                        {!called && userInfoLoading ? (
                            <OptionsSkeleton />
                        ) : (
                            <UserOptions />
                        )}
                    </ContainerSection>
                </ContainerInner>
            </Container>
        </DefaultLayout>
    );
};
